<rask-page [pageTitle]="texts.produktionsomraden" noPadding>
    <rask-list [data]="produktionsomraden">
        <rask-list-column [header]="texts.produktionsomrade" field="namn" [sortable]="true">
            <ng-template let-row="row">
                <a href="#" (click)="openDetail($event, row.id)">{{row.namn}}</a>
            </ng-template>
        </rask-list-column>
        <rask-list-column [header]="texts.resultatomrade" field="resultatomradeNamn" [sortable]="true"></rask-list-column>
    </rask-list>
</rask-page>
